import { render, staticRenderFns } from "./Actions.vue?vue&type=template&id=63d06c3a&scoped=true"
import script from "./Actions.vue?vue&type=script&lang=js"
export * from "./Actions.vue?vue&type=script&lang=js"
import style0 from "./Actions.vue?vue&type=style&index=0&id=63d06c3a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d06c3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63d06c3a')) {
      api.createRecord('63d06c3a', component.options)
    } else {
      api.reload('63d06c3a', component.options)
    }
    module.hot.accept("./Actions.vue?vue&type=template&id=63d06c3a&scoped=true", function () {
      api.rerender('63d06c3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/gestion/campaign/Evaluate/partials/Actions.vue"
export default component.exports